'use strict';

require('styles/templates/page/page.shop-all.scss');

var _GridItem = require('components/GridItem');

var _GridItem2 = _interopRequireDefault(_GridItem);

var _DataSelector = require('common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _IngridHeight = require('components/IngridHeight');

require('components/StrapGuide/Collection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setQuickviewTriggers = function setQuickviewTriggers() {
  var quickviewTriggerSelector = new _DataSelector2.default('data-quickview-trigger');

  quickviewTriggerSelector.nodes().forEach(function (el) {
    return el.dataset[quickviewTriggerSelector.key()] = 'modal';
  });
};

document.addEventListener('DOMContentLoaded', function () {
  _GridItem2.default.bindActions();

  setQuickviewTriggers();
  (0, _IngridHeight.init)();
});

window.addEventListener('load', function () {
  setTimeout(_IngridHeight.init, 0);
});